
import {Component, Mixins, Prop, Ref, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import AlacakBelgeTuruPicker from "@/components/pickers/AlacakBelgeTuruPicker.vue";
import {AlacakBelgeTuruEntity} from "@/entity/AlacakBelgeTuruEntity";
import CekAlacakForm from "@/components/forms/alacak/CekAlacakForm.vue";
import FaturaAlacakForm from "@/components/forms/alacak/FaturaAlacakForm.vue";
import BonoAlacakForm from "@/components/forms/alacak/BonoAlacakForm.vue";
import KiraKontratiAlacakForm from "@/components/forms/alacak/KiraKontratiAlacakForm.vue";
import KiraSozlesmesiTahliyeTaahhuduAlacakForm
  from "@/components/forms/alacak/KiraSozlesmesiTahliyeTaahhuduAlacakForm.vue";
import RehinBelgesiAlacakForm from "@/components/forms/alacak/RehinBelgesiAlacakForm.vue";
import IpotekAkitTablosuAlacakForm from "@/components/forms/alacak/IpotekAkitTablosuAlacakForm.vue";
import NoterSenediAlacakForm from "@/components/forms/alacak/NoterSenediAlacakForm.vue";
import PoliceAlacakForm from "@/components/forms/alacak/PoliceAlacakForm.vue";
import SenetAlacakForm from "@/components/forms/alacak/SenetAlacakForm.vue";
import SozlesmeAlacakForm from "@/components/forms/alacak/SozlesmeAlacakForm.vue";
import TuketiciHakemHeyetiKarariAlacakForm from "@/components/forms/alacak/TuketiciHakemHeyetiKarariAlacakForm.vue";
import DigerAlacakForm from "@/components/forms/alacak/DigerAlacakForm.vue";
import MtsAlacakForm from "@/components/forms/alacak/MtsAlacakForm.vue";
import IsciAlacakForm from "@/components/forms/alacak/IsciAlacakForm.vue";
import TazminatAlacakForm from "@/components/forms/alacak/TazminatAlacakForm.vue";
import CocukTeslimiAlacakForm from "@/components/forms/alacak/CocukTeslimiAlacakForm.vue";
import KisiselIliskiAlacakForm from "@/components/forms/alacak/KisiselIliskiAlacakForm.vue";
import BirIsinYapilmasiVeyaYapilmamasiAlacakForm
  from "@/components/forms/alacak/BirIsinYapilmasiVeyaYapilmamasiAlacakForm.vue";
import IseIadeAlacakForm from "@/components/forms/alacak/IseIadeAlacakForm.vue";
import IrtifakVeyaIntifaHakkininKaldirilmasiAlacakForm
  from "@/components/forms/alacak/IrtifakVeyaIntifaHakkininKaldirilmasiAlacakForm.vue";
import IlamsizNafakaAlacakForm from "@/components/forms/alacak/IlamsizNafakaAlacakForm.vue";
import IlamliNafakaAlacakForm from "@/components/forms/alacak/IlamliNafakaAlacakForm.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import {AlacakBelgeTuru} from "@/enum/AlacakBelgeTuru";
import {AlacakEntity} from "@/entity/AlacakBelgeler/AlacakEntity";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";
import {StatusCodeHelper} from "@/helpers/StatusCodeHelper";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";
import {FaizTuruEntity} from "@/entity/FaizTuruEntity";
import {TakipTipi} from "@/enum/TakipTipi";
import ApartmanAlacakForm from "@/components/forms/alacak/ApartmanAlacakForm.vue";
import {TakipAltTipHesapAyarEntity} from "@/entity/TakipAltTipHesapAyarEntity";

@Component({
  components: {
    ApartmanAlacakForm,
    FormWrapper,
    IlamsizNafakaAlacakForm,
    IlamliNafakaAlacakForm,
    IrtifakVeyaIntifaHakkininKaldirilmasiAlacakForm,
    IseIadeAlacakForm,
    BirIsinYapilmasiVeyaYapilmamasiAlacakForm,
    KisiselIliskiAlacakForm,
    CocukTeslimiAlacakForm,
    IsciAlacakForm,
    TazminatAlacakForm,
    DigerAlacakForm,
    TuketiciHakemHeyetiKarariAlacakForm,
    SozlesmeAlacakForm,
    SenetAlacakForm,
    PoliceAlacakForm,
    KiraSozlesmesiTahliyeTaahhuduAlacakForm,
    RehinBelgesiAlacakForm,
    IpotekAkitTablosuAlacakForm,
    KiraKontratiAlacakForm,
    BonoAlacakForm,
    FaturaAlacakForm,
    MtsAlacakForm,
    CekAlacakForm,
    NoterSenediAlacakForm,
    AlacakBelgeTuruPicker,
  },
})
export default class AlacakForm extends Mixins(ObjectInputMixin) {
  @Prop({required: true}) takipTalebi!: any;
  @Prop({default: false}) edit !: boolean;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;
  @Prop() mtsDurumu !: boolean;
  @Prop() takip !: any;
  @Prop() alacakDetay !: any;
  @Prop() alacakKalemleri!:any
  @Prop() ihtarlar!:any
  @Prop() protestolar!:any
  @Prop() tasinirlar!:any
  @Prop() tasinmazlar!:any

  @Ref('formWrapper') formWrapper!: FormWrapper;
  AlacakBelgeTuru = AlacakBelgeTuru;
  errorAlacakKalemleri: boolean = false;
  hideButton: boolean = false;
  alacakBelgeTuruId:number=0
  StatusCodeHelper = new StatusCodeHelper();
  TakipTipi = TakipTipi
  alacakLoading = false
  @Watch("localValue.alacak_kalemleri")
  onAlacakKalemleriChange() {
    if (this.alacakKalemleri && this.alacakKalemleri.length > 0) {
      this.errorAlacakKalemleri = false;
    }
  }

  @Watch("localValue.alacak_belge_turu_id")
  cahngeBelgeTuru(){
    if (this.takipTalebi.takip_tipi_id===(this.TakipTipi.paraBorcuVeyaTeminat || this.TakipTipi.menkulTeslimi ||
        this.TakipTipi.cocukTeslimi || this.TakipTipi.ipotekIcraEmri || this.TakipTipi.tasinirRehni)){
      this.$http.get(`/api/v1/takip-alt-tip-ilam?takip_alt_tip_id=${this.takipTalebi.takip_tipi_id}&alacak_belge_tur_id=${this.localValue.alacak_belge_turu_id}`)
          .then((response:any) => {
            this.localValue.ilam_tipi = response[0].ilam_tipi;
            this.localValue.mahkeme_id = response[0].mahkeme_id;
            this.localValue.noter_id = response[0].noter_id;
            this.localValue.ilami_veren_kurum = response[0].ilam_veren_kurum;
            this.input()
          });
    }
  }

  addAlacakKalemi(){
    this.$emit('addAlacakKalemi')
  }
  addTasinmaz(){
    this.$emit('addTasinmaz')
  }
  addTasinir(){
    this.$emit('addTasinir')
  }
  addIhtar(){
    this.$emit('addIhtar')
  }
  addProtesto(){
    this.$emit('addProtesto')
  }

  mounted() {


    if (this.mtsDurumu) {
      this.takipTipiChange({id: 9,isim:'',alacak_turleri:[]});
    }
  }

  // TODO: Watchla silmek yanlış en son kaydedildiği zaman switch kontrol edilip silinecek

  //protesto switchi false olduğunda tüm protestoları siler
  @Watch("localValue.protesto_var_mi")
  onProtestoVarMiChange() {
    if (!this.localValue.protesto_var_mi) {
      this.localValue?.protestolar?.forEach((protesto:any) => {
        if (protesto.id) {
          this.$http.delete(
              `/api/v1/alacak/${this.localValue.id}/protesto/${protesto.id}`
          );
          this.localValue.protestolar = []
        }
      });
    }
  }

  //ihtar switchi false olduğunda tüm ihtarları siler
  @Watch("localValue.ihtar_var_mi")
  onIhtarVarMiChange() {
    if (!this.localValue.ihtar_var_mi) {
      this.localValue?.ihtarlar?.forEach((ihtar:any) => {
        if (ihtar.id) {
          this.$http.delete(
              `/api/v1/alacak/${this.localValue.id}/ihtar/${ihtar.id}`
          );
          this.localValue.ihtarlar = []
        }
      });
    }
  }

  load() {
    if (this.localValue.id) {
      this.$http
          .get('/api/v1/takip/' + this.$route.params.id + '/alacak/' + this.localValue.id)
          .then((response) => {
            this.localValue = response.data;

            if (response.data.ihtarlar) {
              response.data.ihtarlar = response.data.ihtarlar.map(
                  (ihtar: any) => {
                    let data = {
                      ...ihtar,
                      ...ihtar.ihtar,
                    };

                    return data;
                  }
              );
            }

            if (response.data.protestolar) {
              response.data.protestolar = response.data.protestolar.map(
                  (protesto: any) => {
                    let data = {
                      ...protesto,
                      ...protesto.protesto,
                    };

                    return data;
                  }
              );
            }
            if (response.data.asil_alacaklar) {
              response.data.alacak_kalemleri = [
                ...response.data.asil_alacaklar
              ]
            }
          });
    }
  }

  takipTipiChange(alacakBelgeTuru: AlacakBelgeTuruEntity) {
    this.localValue = new AlacakEntity();
    this.localValue.alacak_belge_turu_id = alacakBelgeTuru.id;
    if ((this.localValue.alacak_belge_turu_id === AlacakBelgeTuru.cocukTeslimi) ||
        (this.localValue.alacak_belge_turu_id === AlacakBelgeTuru.kisiselIliski) ||
        (this.localValue.alacak_belge_turu_id === AlacakBelgeTuru.birIsinYapilmasiYaDaYapilmamasi && this.takipTalebi.takip_tipi.takip_tipi_eski_no == "54") ||
        (this.localValue.alacak_belge_turu_id === AlacakBelgeTuru.tazminat)
    ) {
      this.hideButton = false;
    }
    this.alacakBelgeTuruId=this.localValue.alacak_belge_turu_id

    this.input();
  }

  save() {
    let alacakKalemiData = []

    if (this.localValue.id){
      alacakKalemiData = this.alacakKalemleri
    }else{
      alacakKalemiData = this.localValue.asil_alacaklar
    }

    if (alacakKalemiData.length > 0 ||
        this.takipTalebi.takip_tipi_id == TakipTipi.menkulTeslimi ||
        this.takipTalebi.takip_tipi_id == TakipTipi.cocukTeslimi||
        this.takipTalebi.takip_tipi_id == TakipTipi.tahliye) {
      this.formWrapper.onFly = true;
      if (this.localValue.id)
        this.update().finally(() => {
          this.errorAlacakKalemleri = false;
          this.formWrapper.onFly = false;
        });
      else
        this.create().finally(() => {
          this.errorAlacakKalemleri = false;
          this.formWrapper.onFly = false;
        });
    } else {
      this.errorAlacakKalemleri = true;
    }
  }

  async create() {
    if (this.localValue.takip_tarihli_kurlar)
      await this.addTakipTarihliKurlar();
    if(this.localValue.alacak_belge_turu_id!=this.AlacakBelgeTuru.apartman_alacagi){
      this.localValue.gecikme_tazminati_mi=false
    }
    console.log('Local------>',this.localValue)

    const { asil_alacaklar, ...payloadWithoutAsilAlacaklar } = this.localValue;
    const response:any = await this.$http.post(`/api/v1/takip-talebi/${this.takipTalebi.id}/alacak`, {
      ...payloadWithoutAsilAlacaklar,
      takip_tipi_id: this.takipTalebi.takip_tipi_id,
      aylik_eklenen_nafaka_faiz_tur_id:this.localValue.takip_sonrasi_faiz_turu_id,
      aylik_eklenen_nafaka_faiz_tur_id:this.localValue.asil_alacaklar[0].takip_sonrasi_faiz_turu_id
    }).catch((error:any) => this.StatusCodeHelper.error(error));
    this.localValue.id = response.data.id;
    await this.checkForm(response.data.id, this.localValue);
    this.$emit("onSuccess");
  }

  async update() {
    if (this.localValue.takip_tarihli_kurlar)
      await this.addTakipTarihliKurlar();
    if(this.localValue.alacak_belge_turu_id!=this.AlacakBelgeTuru.apartman_alacagi){
      this.localValue.gecikme_tazminati_mi=false
    }
    const { asil_alacaklar,tasinir_var_mi,tasinmaz_var_mi, ...payloadWithoutAsilAlacaklar } = this.localValue;
    const response:any = await this.$http.put(`/api/v1/alacak/${this.localValue.id}`, {
      ...payloadWithoutAsilAlacaklar,
      takip_tipi_id: this.takipTalebi.takip_tipi_id,
      takip_talebi_id: this.takipTalebi.id,
    }).catch(error => this.StatusCodeHelper.error(error));
    /*await this.checkFormUpdate(response.data.id, this.localValue);*/
    this.$emit("onSuccess");
  }

  async addTakipTarihliKurlar() {
    let kayitli = this.localValue.takip_tarihli_kurlar.filter((kur:any) => kur.id);
    let yeni = this.localValue.takip_tarihli_kurlar.filter((kur:any) => !kur.id);
    if (kayitli.length > 0) {
      for (const kur of kayitli) {
        await this.$http.put(`/api/v1/takip-tarihli-kur/${kur.id}`, {...kur, tarih: this.takipTalebi.takipTarihi});
      }
    }
    if (yeni.length > 0) {
      for (const kur of yeni) {
        if (this.localValue.para_birimi_id == kur.para_birimi_id || this.localValue.asil_alacaklar.find((alacak:any) => alacak.para_birimi_id == kur.para_birimi_id)) {
          await this.$http.post(`/api/v1/takip/${this.takipTalebi.takip_id}/takip-tarihli-kur`, {
            ...kur,
            tarih: this.takipTalebi.takipTarihi
          });
        }
      }
    }
  }

  /*async checkFormUpdate(id: number, data: any){
    if (data.ihtarlar && data.ihtarlar.length > 0) {
      let ihtar: any;
      for (ihtar of data.ihtarlar) {
        let data = {
          ...ihtar,
          para_birimi_id: 1,
          noter_id: ihtar.noter && ihtar.noter.id,
          aciklama: `İhtar Alacağı`,
        };
        if (data.elle_faiz_oran_mi) {
          if (data.elle_faiz_mi && data.takip_sonrasi_faiz_turu) {
            const faizTuruId = await this.$helper.saveFaizTuru(data.takip_sonrasi_faiz_turu, this.$route.params.id);
            data.takip_oncesi_faiz_turu_id = faizTuruId;
            data.takip_sonrasi_faiz_turu_id = faizTuruId;
          } else {
            data.takip_oncesi_faiz_turu_id = await this.$helper.saveFaizTuru(data.takip_oncesi_faiz_turu, this.$route.params.id);
            data.takip_sonrasi_faiz_turu_id = data.takip_oncesi_faiz_turu_id;
          }
        }
        await this.saveIhtar(id, data);
      }
    }

    if (data.protestolar && data.protestolar.length > 0) {
      let protesto: any;
      for (protesto of data.protestolar) {
        let data = {
          ...protesto,
          para_birimi_id: 1,
          noter_id: protesto.noter && protesto.noter.id,
          aciklama: `Protesto Alacağı`,
        };
        if (data.elle_faiz_oran_mi) {
          if (data.elle_faiz_mi && data.takip_sonrasi_faiz_turu) {
            const faizTuruId = await this.$helper.saveFaizTuru(data.takip_sonrasi_faiz_turu, this.$route.params.id);
            data.takip_oncesi_faiz_turu_id = faizTuruId;
            data.takip_sonrasi_faiz_turu_id = faizTuruId;
          } else {
            data.takip_oncesi_faiz_turu_id = await this.$helper.saveFaizTuru(data.takip_oncesi_faiz_turu, this.$route.params.id);
            data.takip_sonrasi_faiz_turu_id = data.takip_oncesi_faiz_turu_id;
          }
        }
        await this.saveProtesto(id, data);
      }
    }

    if (data.tasinirlar && data.tasinirlar.length > 0) {
      for (let tasinir of data.tasinirlar) {
        await this.saveTasinirlar(id, tasinir);
      }
    }

    if (data.tasinmazlar && data.tasinmazlar.length > 0) {
      for (let tasinmaz of data.tasinmazlar) {
        await this.saveTasinmazlar(id, tasinmaz);
      }
    }
  }*/

  async checkForm(id: number, data: any) {

    if (data.ihtarlar && data.ihtarlar.length > 0 && data.ihtar_var_mi) {
      const ihtarlarPayload = data.ihtarlar.map((ihtar: any) => {
        const { gecikme_tazminati_mi, ...payload } = ihtar;
        return {
          ...payload,
          para_birimi_id: 1,
          aciklama: `İhtar Alacağı`
        };
      });

      await this.$http.post('/api/v1/alacak/' + id + '/ihtarlar-ekle', ihtarlarPayload);
    }

    if (data.protestolar && data.protestolar.length > 0 && data.protesto_var_mi) {
        const protestolarPayload = data.protestolar.map((protesto:any) => {
          const { gecikme_tazminati_mi, ...payload } = protesto;
          return {
            ...payload,
            para_birimi_id:1,
            aciklama:`protesto Alacağı`
          }
        })
      await this.$http.post('/api/v1/alacak/' + id +'/protestolar-ekle',protestolarPayload)
    }

    if (data.tasinirlar && data.tasinirlar.length > 0) {
      await this.$http.post('/api/v1/alacak/' + id +'/tasinirlar-ekle',data.tasinirlar)
    }

    if (data.tasinmazlar && data.tasinmazlar.length > 0) {
      await this.$http.post('/api/v1/alacak/' + id +'/tasinmazlar-ekle',data.tasinmazlar)
    }

    if (data.asil_alacaklar && data.asil_alacaklar.length > 0) {
      this.alacakLoading = true

      const payload = [];
      for (const alacak of data.asil_alacaklar) {
        if(this.localValue.alacak_belge_turu_id!=this.AlacakBelgeTuru.apartman_alacagi){
          alacak.gecikme_tazminati_mi=false
        }
        if (alacak.elle_faiz_oran_mi) {
          if (alacak.elle_faiz_mi && alacak.takip_sonrasi_faiz_turu) {
            const faizTuruId = await this.$helper.saveFaizTuru(alacak.takip_sonrasi_faiz_turu, this.$route.params.id);
            alacak.takip_oncesi_faiz_turu_id = faizTuruId;
            alacak.takip_sonrasi_faiz_turu_id = faizTuruId;
          } else {
            alacak.takip_oncesi_faiz_turu_id = await this.$helper.saveFaizTuru(alacak.takip_oncesi_faiz_turu, this.$route.params.id);
            alacak.takip_sonrasi_faiz_turu_id = alacak.takip_oncesi_faiz_turu_id;
          }
        }

        const { para_birimi, takip_oncesi_faiz_turu, takip_sonrasi_faiz_turu, ...cleanAlacak } = alacak;
        payload.push({
          ...cleanAlacak,
          alacak_kalemi_alani_id: 1,
          takip_oncesi_faiz_turu:alacak.takip_oncesi_faiz_turu,
          takip_sonrasi_faiz_turu:alacak.takip_sonrasi_faiz_turu,
          takip_id:Number(this.$route.params.id),
        });
      }

      await this.$http.post('/api/v1/alacak/' + id + '/alacak-kalemi-ekle', payload).finally(() => {
        this.alacakLoading = false;
      });
    }
  }

  async saveIhtar(id: number, data: any) {
    if(this.localValue.alacak_belge_turu_id!=this.AlacakBelgeTuru.apartman_alacagi){
      data.gecikme_tazminati_mi=false
    }
    if (data.id) {
      return await this.$http.put(`/api/v1/alacak/${id}/ihtar`, data).catch(error => this.StatusCodeHelper.error(error));
    }
    return await this.$http.post(`/api/v1/alacak/${id}/ihtar`, data).catch(error => this.StatusCodeHelper.error(error));
  }

  async saveProtesto(id: number, data: any) {
    if(this.localValue.alacak_belge_turu_id!=this.AlacakBelgeTuru.apartman_alacagi){
      data.gecikme_tazminati_mi=false
    }
    if (data.id) {
      return await this.$http.put(`/api/v1/alacak/${id}/protesto`, data).catch(error => this.StatusCodeHelper.error(error));
    }
    return await this.$http.post(`/api/v1/alacak/${id}/protesto`, data).catch(error => this.StatusCodeHelper.error(error));
  }

  async saveAlacakKalemi(id: number, data: any) {
    if(this.localValue.alacak_belge_turu_id!=this.AlacakBelgeTuru.apartman_alacagi){
      data.gecikme_tazminati_mi=false
    }
    if (data.id) {
      return await this.$http.put(`/api/v1/alacak-kalemi/${data.id}`, data).catch(error => this.StatusCodeHelper.error(error));
    }
    return await this.$http.post(`/api/v1/alacak/${id}/alacak-kalemi`, data).catch(error => this.StatusCodeHelper.error(error));
  }

  async saveTasinirlar(id: number, data: any) {
    if(this.localValue.alacak_belge_turu_id!=this.AlacakBelgeTuru.apartman_alacagi){
      data.gecikme_tazminati_mi=false
    }
    if (data.id) {
      return await this.$http.put(`/api/v1/tasinir/${data.id}`, data).catch(error => this.StatusCodeHelper.error(error));
    }
    return await this.$http.post(`/api/v1/alacak/${id}/tasinirlar`, data).catch(error => this.StatusCodeHelper.error(error));
  }

  async saveTasinmazlar(id: number, data: any) {
    if(this.localValue.alacak_belge_turu_id!=this.AlacakBelgeTuru.apartman_alacagi){
      data.gecikme_tazminati_mi=false
    }
    if (data.id) {
      return await this.$http.put(`/api/v1/tasinmaz/${data.id}`, data).catch(error => this.StatusCodeHelper.error(error));
    }
    return await this.$http.post(`/api/v1/alacak/${id}/tasinmazlar`, data).catch(error => this.StatusCodeHelper.error(error));
  }

  alacakKalemindenElleFaizGetir(alacakKalemi: AlacakKalemiEntity) {
    return alacakKalemi.children?.filter((child: AlacakKalemiEntity) => child.alacak_kalemi_alani_id == AlacakKalemiAlani.takipOncesiFaiz && !child.is_calculated)[0];
  }
  deleteAsilAlacak(){
    this.$emit('delete')
  }
  deleteIhtar(){
    this.$emit('deleteIhtar')
  }
  deleteProtesto(){
    this.$emit('deleteProtesto')
  }
  deleteTasinmaz(){
    this.$emit('deleteTasinmaz')
  }
  deleteTasinir(){
    this.$emit('deleteTasinir')
  }
}
